import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { fetchPlayerSong } from '../../actions/PlayerActions';
import { connect } from 'react-redux';

import { 
  FrameDetails, 
  FrameDetailsDivider, 
  FrameDetailsTitle, 
  FrameDetailsSubTitle,
  FrameDetailsBackground
} from '../HelperComponents/StyledComponents';

class FooterFrameComponent extends Component {
  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    price: PropTypes.number,
    body: PropTypes.any,
    foot: PropTypes.any
  };

  render() {
    return (
      <FrameDetails className="hero-foot">
        <FrameDetailsBackground/>
        <section className="columns is-vcentered">
          <section className="column">
            <section className="columns is-vcentered is-mobile">
              <FrameDetailsDivider className="column is-narrow has-text-centered" theme={{ direction: 'right', borderValues: '1px solid #FFF' }} style={{ zIndex: 1 }}>
                <span className="icon-play has-text-white" style={{ fontSize: '31px', padding: '5px', cursor: 'pointer' }} onClick={() => { this.props.fetchPlayerSong(this.props.song); }}></span>
              </FrameDetailsDivider>

              <section className="column is-11" style={{zIndex: 1}}>
                <FrameDetailsTitle>
                  {this.props.title}
                </FrameDetailsTitle>
                <FrameDetailsSubTitle>
                  {this.props.subtitle}
                </FrameDetailsSubTitle>
              </section>
            </section>
          </section>
        </section>
      </FrameDetails>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchPlayerSong }, dispatch);
}

export const FooterFrame = connect(null, mapDispatchToProps)(FooterFrameComponent);


// WEBPACK FOOTER //
// ./src/components/FooterFrame/FooterFrame.js